// Dory Brand Design System
export const theme = {
  // Colors
  colors: {
    primary: {
      main: '#405C73',      // Dory Blue
      dark: '#3B515D',      // Dory Darker Blue  
      light: '#9CB0BD',     // Dory Lighter Blue
    },
    secondary: {
      beige: '#F2F2F2',     // Dory Beige - Background/neutral
      green: '#435F60',     // Dory Green - Accent color
      black: '#121616',     // Dory Black - Text/dark elements
    },
    status: {
      success: '#435F60',   // Using Dory Green
      warning: '#F4A261',   // Warm accent
      error: '#E76F51',     // Error state
      info: '#9CB0BD',      // Using Dory Light Blue
    },
    chart: {
      primary: '#405C73',
      secondary: '#435F60', 
      tertiary: '#9CB0BD',
      quaternary: '#3B515D',
      background: '#F2F2F2',
      text: '#121616',
    }
  },

  // Typography
  typography: {
    // Primary Font: Cairo SemiBold
    heading: {
      fontFamily: "'Cairo', sans-serif",
      fontWeight: 600,
      h1: {
        fontSize: '44px',
        lineHeight: '1.2',
        fontWeight: 700,
      },
      h2: {
        fontSize: '30px', 
        lineHeight: '1.3',
        fontWeight: 600,
      },
      h3: {
        fontSize: '20px',
        lineHeight: '1.4',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.2em',
      },
    },
    
    // Secondary Font: IBM Plex Sans
    body: {
      fontFamily: "'IBM Plex Sans', sans-serif",
      p1: {
        fontSize: '18px',
        lineHeight: '1.5',
        fontWeight: 400,
      },
      p2: {
        fontSize: '14px',
        lineHeight: '1.6', 
        fontWeight: 500,
      },
      p3: {
        fontSize: '10px',
        lineHeight: '1.3',
        fontWeight: 500,
      },
    },
  },

  // Spacing
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },

  // Breakpoints for mobile-first design
  breakpoints: {
    mobile: '320px',
    tablet: '768px', 
    desktop: '1024px',
    large: '1200px',
  },

  // Shadows
  shadows: {
    card: '0 2px 8px rgba(64, 92, 115, 0.1)',
    hover: '0 4px 16px rgba(64, 92, 115, 0.15)',
    active: '0 1px 4px rgba(64, 92, 115, 0.2)',
  },

  // Border radius
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%',
  },
}

// Media query helpers
export const mediaQuery = {
  mobile: `@media (min-width: ${theme.breakpoints.mobile})`,
  tablet: `@media (min-width: ${theme.breakpoints.tablet})`,
  desktop: `@media (min-width: ${theme.breakpoints.desktop})`,
  large: `@media (min-width: ${theme.breakpoints.large})`,
} 